const __default__ = {
  name: "Header",
  computed: { ...mapState(["school", "isLoggedIn", "studentAddress", "me", "version", "capabilities"])
  }
};
import { ref, computed } from "vue";
import { storeToRefs } from "pinia";
import { useSchoolPlanStore } from "@/stores/schoolPlan";
import { mapState } from "vuex";
import { logout } from "@/services/auth";
import RowItem from "../RowItem";
import { useStore } from "vue2-helpers/vuex";
import { formatPhoneNumber } from "@/services/common";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props, {
    expose
  }) {
    const {
      schoolPlan
    } = storeToRefs(useSchoolPlanStore());
    const showMenuOne = ref(false);
    const showMenuTwo = ref(false);
    const store = useStore();
    const phoneAttendance = computed(() => {
      return formatPhoneNumber(store.state.school.phone_attendance);
    });
    const phoneMessage = computed(() => {
      return formatPhoneNumber(store.state.school.phone_message);
    });

    const hideMenuTwo = () => {
      if (showMenuTwo.value) {
        showMenuTwo.value = false;
      }
    };

    expose({
      schoolPlan
    });
    return {
      __sfc: true,
      schoolPlan,
      showMenuOne,
      showMenuTwo,
      store,
      phoneAttendance,
      phoneMessage,
      hideMenuTwo,
      logout,
      RowItem
    };
  }

});